module.exports = __webpack_public_path__ + "static/media/pebbble1.c887bb45.png";